import React, { useEffect, useState } from "react";
import {
  StyledButtonGitHub,
  StyledPaper,
} from "./dashboard.css";
import { useAuth } from "../../contexts/AuthContext";
import { Grid, CardMedia } from "@material-ui/core";
import imgUrl from "../../components/assets/images/pdfImg.png";
import Header from "../Header/Header";
import firebase from "firebase";
import Snackbar from "../CommonComponent/Snackbar/Snackbar";

/* Dashboard component  */
function Dashboard() {
  const { currentUser } = useAuth();
  const [image, setImage] = useState("");
  const [downloadUrl, setDownloadUrl] = useState();
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    snackbarMsg: "",
    type: "",
  });


  useEffect(() => {
    if(snackbarProps.open === true){
      setTimeout(()=> {
        setSnackbarProps({ open: false})
      },3000)
    }
  }, [snackbarProps]);


  /* download all files form database */
  const handlePdfDownload1 = async () => {
    const storage = firebase.storage();
    try {
      const listRef = storage.ref(`/files/${currentUser.email}`);
      const list = await listRef.listAll();
      const refList = list.items.map((item) => item);
      const pathList = await Promise.all(
        refList.map(async (itemRef) => {
          const fileName = itemRef.location.path_
          const url = await storage
            .ref(itemRef.location.path_)
            .getDownloadURL();
          return {
            pathUrl: url,
            fileName: fileName
          };
        })
      );
      setDownloadUrl(pathList);
      setSnackbarProps({
        open: true,
        snackbarMsg: "Files Found!",
        type: "success",
      });
    } catch (err) {
      setSnackbarProps({
        open: true,
        snackbarMsg: "No Files Found!",
        type: "error",
      });
    }

  };
  return (
    <>
      <Header />
      <Grid container >
        <Grid item xs={12}>
          <StyledPaper style={{backgroundColor: 'white'}}>
            <Grid container>
              <Grid item xs={6}>
                <CardMedia
                  component="img"
                  image={imgUrl}
                  alt={"img"}
                  style={{
                    width: "50%",
                  }}
                />
                <StyledButtonGitHub
                  variant="contained"
                  type="button"
                  onClick={handlePdfDownload1}
                >
                  Click here to show files
                </StyledButtonGitHub>
              </Grid>
               <Grid item xs={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <p style={{fontWeight: 'bold'}}>*As part of our Go-Green initiative, all communication including investment statements will be uploaded on this LP portal and notifications would be sent to the investor's registered email id. In case of any queries, please reach out to us at <a href="mailto:finance@sparrowvc.com">finance@sparrowvc.com</a></p>
                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-evenly",
                    padding: "10px",
                    marginBottom: "10px",
                    fontSize: "30px"
                  }}
                >
                  {downloadUrl &&
                    downloadUrl.map((link, idx) => {
                      const name = link.fileName.split(`/${currentUser.email}/`)[1]
                      return (
                        <li>
                          <a
                            target="_blank"
                            href={link.pathUrl}
                            style={{
                              marginBottom: "10px",
                              color: 'black'
                            }}
                            key = {idx}
                          >{name}</a>
                          </li>
                      );
                    })}
                </ul>
              </Grid>
            </Grid>
          </StyledPaper>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarProps.open}
        message={snackbarProps.snackbarMsg}
        type={snackbarProps.type}
      ></Snackbar>
    </>
  );
}

export default Dashboard;
